import { useQueryClient } from '@tanstack/react-query';
import { ApiError, useApi } from '@/hooks/useApi';
import { useModeAwareMutation } from '@/hooks/useModeAwareQuery';

export interface LogCustomerPhoneCallRequest {
  customerId: string;
  phoneNumber?: string;
  durationMinutes?: number;
  notes?: string;
  outcome?: string;
  contactId?: number;
  followUpDate?: string;
  direction?: string;
}

export function useLogCustomerPhoneCall() {
  const { apiBaseUrl, getHeaders } = useApi();
  const queryClient = useQueryClient();

  return useModeAwareMutation<void, Error, LogCustomerPhoneCallRequest>(
    async (request) => {
      const { customerId, ...body } = request;
      const headers = await getHeaders();
      const response = await fetch(`${apiBaseUrl}/api/v1/customers/${customerId}/communications/log-call`, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new ApiError(errorData.message || `HTTP error ${response.status}`, response.status, errorData);
      }
      // 201 Created with null body — no need to parse JSON
    },
    () => {
      // Demo mode: no-op, just return void
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['customers'] });
        queryClient.invalidateQueries({ queryKey: ['customer-communications'] });
        queryClient.invalidateQueries({ queryKey: ['customer-recent-activities'] });
        queryClient.invalidateQueries({ queryKey: ['customer-audit-logs'] });
      },
    },
  );
}
